import * as leaflet from './leaflet'
import * as leafletSleep from './leaflet-sleep'
import * as geoman from './geoman'

export default {
  leafletSleep,
  leaflet,
  geoman,
}
